import React, { useState, useEffect, useRef } from 'react';
import { dbPost } from '../../apis/commonApi';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';

const SelectBox = ({ id, options, defaultText, onChange }) => (
  <select
    id={id}
    className="form-select md"
    onChange={e => onChange(e.target.value)}
  >
    <option value="">{defaultText}</option>
    {options.map((option, index) => (
      <option key={index} value={option}>
        {option}
      </option>
    ))}
  </select>
);

const TableRow = ({ rows }) =>
  rows.map((row, rowIndex) => (
    <tr key={`row-${rowIndex}`}>
      {row.map((cell, cellIndex) =>
        cell.content !== null ? (
          <td
            key={`cell-${rowIndex}-${cellIndex}`}
            className={cell.className || ''}
            rowSpan={cell.rowSpan || 1}
          >
            {cell.content}
          </td>
        ) : null
      )}
    </tr>
  ));

const TaskStats = () => {
  useEffect(() => {
    document.title = '통계 - 공정/작업 등록 현황';
  }, []);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [entNmOptions, setEntNmOptions] = useState([]);
  const [bizTypeNameOptions, setBizTypeNameOptions] = useState([]);
  const [selectedEntNm, setSelectedEntNm] = useState('');
  const [selectedBizTypeName, setSelectedBizTypeName] = useState('');
  const [totalCnt, setTotalCnt] = useState(0);

  const fetchSelectOptions = async () => {
    try {
      const response = await dbPost('/stats/taskStats/selectSearch.do');
      if (response && Array.isArray(response)) {
        const bizTypeNames = response
          .filter(item => item.type === 'bizTypeName')
          .map(item => item.name);
        const entNms = response
          .filter(item => item.type === 'entNm')
          .map(item => item.name);

        setBizTypeNameOptions(bizTypeNames);
        setEntNmOptions(entNms);
      }
    } catch (error) {}
  };

  const fetchTaskData = async (filters = {}) => {
    try {
      const response = await dbPost('/stats/taskStats/search.do', {
        ...filters,
        currentPage,
        pageSize: itemsPerPage,
      });

      if (response && Array.isArray(response)) {
        setTotalCnt(response[0]?.totalCount || 0);
        setTableData(groupByBizTypeName(response));
      }
    } catch (error) {}
  };

  useEffect(() => {}, [entNmOptions]);

  useEffect(() => {}, [bizTypeNameOptions]);

  const groupByBizTypeName = data => {
    const grouped = {};
    data.forEach(item => {
      if (!grouped[item.bizTypeName]) {
        grouped[item.bizTypeName] = [];
      }
      grouped[item.bizTypeName].push(item);
    });

    const tableRows = [];
    let sequence = (currentPage - 1) * itemsPerPage + 1;

    Object.entries(grouped).forEach(([bizTypeName, items]) => {
      const rowSpan = items.length;
      items.forEach((item, index) => {
        tableRows.push([
          {
            content: index === 0 ? sequence++ : null,
            rowSpan: index === 0 ? rowSpan : null,
          },
          {
            content:
              index === 0 ? (
                <span className="krds-badge-biz">{bizTypeName}</span>
              ) : null,
            rowSpan: index === 0 ? rowSpan : null,
          },
          {
            content: item.processName ? (
              <strong>{item.processName}</strong>
            ) : (
              '-'
            ),
          },
          {
            content: item.userCount,
          },
        ]);
      });
    });

    return tableRows;
  };

  const [searchFilters, setSearchFilters] = useState({
    bizTypeName: '',
    entNm: '',
  });

  const handleSearch = () => {
    setCurrentPage(1);
    const newFilters = {
      bizTypeName: selectedBizTypeName,
      entNm: selectedEntNm,
    };
    setSearchFilters(newFilters);
    fetchTaskData({ ...newFilters, currentPage: 1 });
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchSelectOptions();
  }, []);

  useEffect(() => {
    fetchTaskData({ ...searchFilters, currentPage });
  }, [currentPage]);

  return (
    <div className="contents">
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">공정/작업 등록 현황</h2>
      </div>

      <div className="tbl-wrap">
        <table className="tbl data row">
          <caption>
            통계 - 공정/작업 등록 현황 조회를 위한 테이블입니다.
          </caption>
          <tbody>
            <tr>
              <th scope="row">등록 현황 조회</th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="sel1">
                    기업 선택
                  </label>
                  <SelectBox
                    id="sel1"
                    options={entNmOptions}
                    defaultText="기업 선택"
                    onChange={setSelectedEntNm}
                    aria-labelledby="entNmOptions"
                  />
                  <label className="hidden-label" htmlFor="sel2">
                    업종 선택
                  </label>
                  <SelectBox
                    id="sel2"
                    options={bizTypeNameOptions}
                    defaultText="업종 선택"
                    onChange={setSelectedBizTypeName}
                    aria-labelledby="bizTypeNameOptions"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="page-btn-wrap gap-lg">
        <button
          type="button"
          className="btn xlg primary"
          onClick={handleSearch}
        >
          검색하기
        </button>
      </div>

      <div className="tbl-wrap">
        <h3 className="block-tit">등록 현황</h3>
        <table className="tbl col data scroll">
          <caption>조회된 공정/작업 결과 테이블입니다.</caption>
          <colgroup>
            <col
              style={{
                width: '8rem',
              }}
            />
            <col
              style={{
                width: '12rem',
              }}
            />
            <col
              style={{
                width: '30rem',
              }}
            />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">순번</th>
              <th scope="col">업종</th>
              <th scope="col">공정명</th>
              <th scope="col">등록된 기업 수</th>
            </tr>
          </thead>
          <tbody>
            <TableRow rows={tableData} />
          </tbody>
        </table>
      </div>

      <GbitTablePaging
        totalItems={totalCnt}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TaskStats;
